import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Immediate, synchronous scroll to top - executes before browser paint
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
